import React, { createContext, useContext, useState } from 'react';

const DisplayModeContext = createContext(null);

export const useDisplayMode = () => {
  const context = useContext(DisplayModeContext);
  if (!context) {
    throw new Error('useDisplayMode must be used within a DisplayModeProvider');
  }
  return context;
};

export const DisplayModeProvider = ({ children }) => {
  // 'percentages' or 'trips'
  const [displayMode, setDisplayMode] = useState('percentages');

  const value = React.useMemo(() => ({
    displayMode,
    setDisplayMode,
    showPercentages: displayMode === 'percentages',
    showTrips: displayMode === 'trips',
  }), [displayMode]);

  return (
    <DisplayModeContext.Provider value={value}>
      {children}
    </DisplayModeContext.Provider>
  );
};

export default DisplayModeContext;
